import Toggle from "react-toggle";
import React from "react";
import {Controller} from "react-hook-form";

const FormToggle = ( { validate, control, register, name, readOnly, options }) =>
{
    return <Controller
        control={control}
        name={name}
        defaultValue={[]}
        rules={{ required: false, validate: validate}}
        render={({ field: { onChange, value, name, ref },
                     fieldState: { invalid, isTouched, isDirty, error },
                     formState,
                 }) => <Toggle
                name={name}
                disabled={readOnly}
                icons={false}
                onChange={onChange}
                colSpan={6}
                checked={value}
            />}
    />
}

export default FormToggle ;
